module.exports = __webpack_public_path__ + "img/youshi3.734c304a.svg";